import { Provider } from 'cerebral';
import * as Sentry from '@sentry/browser';
import provider from './provider';

function SentryProvider() {
  return new Provider(provider(Sentry));
}

export default SentryProvider;
